import {
    AfterViewInit,
    Component,
    ElementRef,
    Input,
    OnDestroy,
    OnInit,
    Optional,
    QueryList,
    ViewChild,
    ViewChildren
} from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import {Group, LogTail, Query} from 'core-lib';
import { MessageService } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'lib-log-display',
    templateUrl: './log-display.component.html',
    styleUrls: ['./log-display.component.scss'],
    standalone: false
})
export class LogDisplayComponent implements OnInit, OnDestroy, AfterViewInit {

    @Input() batchId: string = "";
    @ViewChild('logWrapper') logWrapper: ElementRef;
    @ViewChildren('batchLog') batchLog: QueryList<any>;
    pos: number = 0;
    loadedLogs: string[] = [];
    errors = {show: false, error: ""}
    intervalId: ReturnType<typeof setInterval> | null = null;

    LOG_QUERY = gql`
    query tailBatchProcessLog($batchId: BatchId!, $pos: Int){
        tailBatchProcessLog(batchId: $batchId, pos: $pos){
            pos
            messages
        }
    }`;

    constructor(private apollo: Apollo, private messageService: MessageService,) {}

    /**
    * init
    */
    ngOnInit(): void {
        this.loadLogs();
        this.intervalId = setInterval(()=>{
            this.loadLogs()
        }, 5000)
    }

    ngOnDestroy(){
        clearInterval(this.intervalId);
    }

    ngAfterViewInit() {
        this.batchLog.changes.subscribe(log => this.onLogsChanged());
    }

    private onLogsChanged(): void {
        this.scrollToBottom();
    }

    private scrollToBottom(): void {
        this.logWrapper.nativeElement.scroll({
            top: this.logWrapper.nativeElement.scrollHeight,
            left: 0,
            behavior: 'smooth'
        });
    }

    loadLogs(): void {
        this.apollo.query<Query>({
            query: this.LOG_QUERY,
            variables: {
                batchId: this.batchId,
                pos: this.pos,
            }
        }).subscribe((result) => {
            if(!result.errors){
                if(result.data.tailBatchProcessLog == null){
                    return clearInterval(this.intervalId);
                }
                this.loadedLogs = [...this.loadedLogs, ...result.data.tailBatchProcessLog.messages];
                this.pos = result.data.tailBatchProcessLog.pos +1;
                this.logWrapper.nativeElement.scrollTop = this.logWrapper.nativeElement.scrollHeight;
            }
            else {
                this.errors.show = true;
                this.errors.error = result.error.message;
            }

        });
    }
}
